import { render, staticRenderFns } from "./VolunteerList.vue?vue&type=template&id=0f55bffe&scoped=true"
import script from "./VolunteerList.vue?vue&type=script&lang=js"
export * from "./VolunteerList.vue?vue&type=script&lang=js"
import style0 from "./VolunteerList.vue?vue&type=style&index=0&id=0f55bffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55bffe",
  null
  
)

export default component.exports